import React from 'react'
import PropTypes from 'prop-types'
import { logger } from 'logger'
import BlockTypes from '@slite/editor/lib/types/BlockTypes'

import ShareToModal from './ShareToModal'

export default class ShareToModalProxy extends React.Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    eventBusStore: PropTypes.object.isRequired,
  }

  componentWillMount() {
    this.props.eventBusStore.updateItem('editor', this.props.editor)
  }

  render() {
    const { editor, eventBusStore } = this.props

    return (
      <ShareToModal
        eventBusStore={eventBusStore}
        createIntegrationTileBlock={({ tileId, createdBy, iconURL }) => {
          if (editor.props.readOnly) {
            logger.error(`We can't create tiles with a read only editor`)
            return
          }

          editor
            .moveTo(editor.value.endBlock.key)
            .moveToEndOfBlock()
            .insertBlock({
              type: BlockTypes.INTEGRATION_TILE,
              data: {
                v: 0,
                iconURL,
                tileId,
                atomic: true, // useful for legacy editor
                depth: 0,
                transient: true,
                collapsed: true,
                title: 'Pending tile...',
                status: {
                  label: 'Pending',
                  colorHex: '#F6F6F6',
                },
                createdBy,
                createdAt: Date.now(),
                updatedAt: Date.now(),
              },
            })
        }}
      />
    )
  }
}
